// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0b2b5f79","389":"6d52eb2a","455":"926e3ce3","970":"3b3f0436","977":"11a82512"}[chunkId] + ".chunk.js";
};